export enum EventSectionLayoutType {
  DEFAULT = 'DEFAULT',
  SPORT = 'SPORT',
  CAMPUS_FOUNDERS = 'CAMPUS_FOUNDERS',
}
